import React, { useState, useEffect } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Footer = () => {
  const { isDarkMode } = useTheme();
  const [stats, setStats] = useState({ total_visits: 0, unique_visitors: 0 });
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const trackVisitor = async () => {
      try {
        // Get or create visitor ID
        let visitorId = localStorage.getItem('visitor_id');
        if (!visitorId) {
          visitorId = uuidv4();
          localStorage.setItem('visitor_id', visitorId);
        }

        // Track the visit and get updated stats
        const response = await axios.post(
          `${API_URL}/api/visitor/track`,
          {},
          { headers: { 'X-Visitor-ID': visitorId } }
        );
        
        setStats({
          total_visits: response.data.total_visits,
          unique_visitors: response.data.unique_visitors
        });
        setLoaded(true);
      } catch (error) {
        console.error('Failed to track visitor:', error);
        // Try to at least get stats
        try {
          const statsResponse = await axios.get(`${API_URL}/api/visitor/stats`);
          setStats(statsResponse.data);
          setLoaded(true);
        } catch (e) {
          // Silent fail - stats will show 0
          setLoaded(true);
        }
      }
    };

    trackVisitor();
  }, []);

  return (
    <footer 
      data-testid="app-footer"
      className={`fixed bottom-0 left-0 right-0 z-40 h-7 flex flex-col items-center justify-center ${
        isDarkMode 
          ? 'bg-[#0a1628] text-gray-500' 
          : 'bg-gray-100 text-gray-400'
      }`}
    >
      <div className="flex items-center gap-2">
        {loaded && (
          <>
            <span 
              data-testid="total-visits" 
              className="flex items-center gap-1 text-[10px]"
            >
              <svg className="w-2.5 h-2.5" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10 12a2 2 0 100-4 2 2 0 000 4z"/>
                <path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd"/>
              </svg>
              {stats.total_visits.toLocaleString()}
            </span>
            <span 
              data-testid="unique-visitors" 
              className="flex items-center gap-1 text-[10px]"
            >
              <svg className="w-2.5 h-2.5" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"/>
              </svg>
              {stats.unique_visitors.toLocaleString()}
            </span>
            <span className="text-[10px]">|</span>
          </>
        )}
        <p className="text-[10px] font-medium" data-testid="footer-credit">
          <a
            href="https://x.com/NoPrayApp"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline transition-colors"
          >
            No Pray App — nopray.com
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
